import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown } from 'react-bootstrap-5';
import { faEdit, faTrashAlt } from '@fortawesome/pro-solid-svg-icons';

import Tooltip from 'components/tooltip';

export default function DropdownMenuItem({
  disabled,
  disabledMessage,
  children,
  icon,
  isDelete,
  isEdit,
  label,
  onClick,
  ...props
}) {
  let content;
  if (children) {
    content = children;
  } else {
    if (isDelete) {
      icon = icon || faTrashAlt;
      label = label || 'Delete';
    } else if (isEdit) {
      icon = icon || faEdit;
      label = label || 'Edit';
    }

    if (icon && !React.isValidElement(icon)) {
      icon = <FontAwesomeIcon fixedWidth icon={icon} />;
    }

    content = icon
      ? <>{icon} {label}</>
      : label;
  }

  if (disabled && disabledMessage) {
    content = (
      <Tooltip content={disabledMessage} dark placement="left">
        <div>{content}</div>
      </Tooltip>
    );
  }

  // pointerEvents: auto allows hover events through for the toolip even when disabled
  return (
    <Dropdown.Item
      disabled={disabled}
      style={{ pointerEvents: 'auto' }}
      onClick={disabled ? null : onClick}
      {...props}
    >
      {content}
    </Dropdown.Item>
  );
}

DropdownMenuItem.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  disabledMessage: PropTypes.string,
  icon: PropTypes.object,
  isDelete: PropTypes.bool,
  isEdit: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};
